<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512">
        <!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path fill="currentColor"
            d="M72 64c0-17.7-14.3-32-32-32S8 46.3 8 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM40 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
    </svg>
</template>

<script>
export default {
    name: "svg-exclamation"
}
</script>
